module.exports = __webpack_public_path__ + "revPerMember1.svg?0b9ba52616f1478c0a195c30470a0187";